import { applicationFeesApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_FEE_CREDITS_ACTION_TYPE = createNamedActions(
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/feeCredits`,
  {
    GET_FEE_CREDITS: 'GET_FEE_CREDITS',
    ADD_FEE_CREDIT: 'ADD_FEE_CREDIT',
    DELETE_FEE_CREDIT: 'DELETE_FEE_CREDIT',
  },
);

export const getLoanFeeCreditsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationFeesApi.getLoanFeeCredits(params);

  return dispatch({
    type: LOAN_FEE_CREDITS_ACTION_TYPE.GET_FEE_CREDITS,
    payload: data,
  });
});

export const deleteLoanFeeCreditAction = catchAsyncActionError(params => async dispatch => {
  await applicationFeesApi.deleteLoanFeeCredit(params);

  return dispatch({
    type: LOAN_FEE_CREDITS_ACTION_TYPE.DELETE_FEE_CREDIT,
    payload: params,
  });
});
